<template>
  <div v-loading="loading" class="search-dialog ignore">
    <div class="content">
      <div class="left">
        <SearchPart
          v-if="searchHistory.length"
          v-model:searchList="searchHistory"
          type="history"
          :sdSearchPageProductBtnClick="SDSearchPageProductBtnClick"
          @innerClick="$emit('innerClick')"
          @search="$emit('search')"
        />
        <SearchPart
          type="hot"
          :searchList="hotList"
          :hasRecently="hasRecently"
          :sdSearchPageProductBtnClick="SDSearchPageProductBtnClick"
          @search="$emit('search')"
        />
      </div>
      <div
        v-if="
          (searchRecommended && searchRecommended.name) ||
          (searchFaq && searchFaq.list && searchFaq.list.length)
        "
        class="right"
      >
        <div v-if="searchRecommended && searchRecommended.name" class="recommend">
          <p class="title">Recommended</p>
          <div
            @click="
              tapRecommend();
              SDSearchPageProductBtnClick({ search_type: 'Recommended' });
            "
          >
            <NuxtImgWrap
              :src="$util.akamai(searchRecommended.recommend_image, 440)"
              alt=""
              loading="lazy"
            />
            <p class="desc">{{ searchRecommended.name }}</p>
          </div>
        </div>
        <div v-if="searchFaq.list && searchFaq.list.length" class="faq">
          <p class="top">
            <span class="title">FAQ</span>
            <a
              class="all"
              href="https://help.vooglam.com/hc/en-us"
              target="_blank"
              @click="SDSearchPageFAQBtnClick('See All')"
              >View More <i class="iconfont icon-xiangyou-xi"></i
            ></a>
          </p>
          <ul>
            <li
              v-for="(item, i) of searchFaq.list"
              :key="i"
              @click="SDSearchPageFAQBtnClick(item.title)"
            >
              <a :href="item.link" :title="item.title" target="_blank">{{ item.title }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchPart from './components/SearchPart.vue';

export default {
  name: 'Search',
  components: { SearchPart },
  props: {
    searchRecommended: {
      type: Object,
      default: () => ({}),
    },
    searchFaq: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['search', 'innerClick'],
  data() {
    return {
      searchHistory: [],
      hotList: [],
      hasRecently: false, // 是否有最近搜索
      loading: false,
    };
  },
  watch: {
    searchHistory() {
      if (this.searchHistory.length === 0) {
        this.getHot();
      }
    },
  },
  methods: {
    async getHistory() {
      try {
        let list = JSON.parse(localStorage.getItem('voo-searchHistory')) || [];
        list = list.filter((item) => !!item);
        if (list.length) {
          await this.getHistoryGoods(list);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getHistoryGoods(list) {
      try {
        const { data } = await this.$api.search.getSearchInfo({
          keywords: list,
        });
        if (data && Array.isArray(data)) {
          data.forEach((keyGoods) => {
            keyGoods.products = keyGoods.products.filter(
              (item) => item.status == 1 && Number(item.stock) > 0,
            );
          });
          this.searchHistory = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getHot() {
      try {
        if (this.hotList.length === 0) {
          this.loading = true;
        }
        let list = JSON.parse(localStorage.getItem('voo-searchHistory')) || [];
        list = list.filter((item) => !!item);
        this.hasRecently = list.length > 0;
        const { data } = await this.$api.search.getHotList({
          is_recently: list.length ? 1 : 2,
        });
        data.forEach((keyGoods) => {
          keyGoods.products = keyGoods.products.filter(
            (item) => item.status == 1 && Number(item.stock) > 0,
          );
        });
        this.hotList = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    tapRecommend() {
      if (this.searchRecommended.url) {
        window.location.href = this.searchRecommended.url;
      } else if (this.searchRecommended.product_group?.id) {
        this.$router.push(`/goods-list/${this.searchRecommended.product_group.id}`);
      }
    },
    /**
     * @TrackType sensorsdata
     * @EventType SearchPageProductBtn_Click
     * @EventDesc 搜索页商品按钮点击
     * @EventParams {
     *  search_type: 搜索类型,
     *  shop_sku: 站点商品sku,
     *  product_sku: 商品sku,
     *  product_id: 商品ID,
     *  product_name: 商品名称,
     * }
     * @Tapd 1009440
     */
    SDSearchPageProductBtnClick(params) {
      try {
        const sdEventName = 'SearchPageProductBtn_Click';
        const sdEventParams = {
          ...params,
        };
        window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * @TrackType sensorsdata
     * @EventType SearchPageFAQBtn_Click
     * @EventDesc 搜索页FAQ按钮点击
     * @EventParams {
     *  btn_name: 按钮名称,
     * }
     * @Tapd 1009440
     */
    SDSearchPageFAQBtnClick(btn_name) {
      try {
        const sdEventName = 'SearchPageFAQBtn_Click';
        const sdEventParams = {
          btn_name,
        };
        window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-dialog.ignore {
  position: absolute;
  z-index: 9;
  right: 0;
  top: 52px;
  padding: 14px 40px 40px;
  border: 1px solid #f4f6f8;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 1px 6px 0 rgb(0 0 0 / 6%);
  box-sizing: border-box;

  @include max-xl {
    right: -100%;
  }

  @include max-lg {
    right: -120%;
  }

  @media screen and (max-width: 920px) {
    right: -140%;
  }
  .content {
    @include flex;
    .left {
      padding-right: 39px;
    }
    .right {
      margin-top: 18px;
      padding-left: 40px;
      width: 220px;
      border-left: 1px solid #f5f5f5;
      .title {
        font-size: 16px;
        font-family: $f-pb;
      }
      .recommend {
        margin-bottom: 40px;
        img {
          width: 220px;
          height: 150px;
          border-radius: 10px;
          object-fit: cover;
        }
        & > div {
          cursor: pointer;
        }
        .desc {
          margin-top: 8px;
          text-align: center;
          color: #080506;
        }
      }
      .faq {
        .top {
          @include flex(space-between);

          align-items: center;
          margin-bottom: 16px;
          .all {
            .icon-xiangyou-xi {
              margin-left: 4px;
              font-size: 14px;
            }

            display: flex;
            align-items: center;
            font-size: 14px;
            color: #080506;
          }
        }
        ul {
          li {
            margin-bottom: 18px;
            cursor: pointer;
            max-width: 220px;

            @include ellipsis;
            a {
              color: #080506;
            }
          }
        }
      }
    }
  }
}
</style>
